import axios from 'axios'
import { api } from '~/config'
import * as types from '../mutation-types'

/**
 * Initial state
 */
export const state = {
  user: null,
  token: window.localStorage.getItem('token'),
  busqueda: null,
  enviarCertificados: null,
  estadoLote: null,
  tipoRvoeLote: null,
}

/**
 * Mutations
 */
export const mutations = {
  [types.SET_USER](state, { user }) {
    state.user = user
  },

  [types.LOGOUT](state) {
    state.user = null
    state.token = null
    state.busqueda = null
    state.enviarCertificados = null
    state.estadoLote = null
    state.tipoRvoeLote = null
    window.localStorage.removeItem('token')
  },

  [types.FETCH_USER_FAILURE](state) {
    state.user = null
    window.localStorage.removeItem('token')
  },

  [types.SET_TOKEN](state, { token }) {
    state.token = token
    window.localStorage.setItem('token', token)
  },

  [types.SET_SEARCH](state, { busqueda }) {
    state.busqueda = busqueda
  },

  [types.SET_ENVIAR_CERTIFICADOS](state, { enviarCertificados }) {
    state.enviarCertificados = enviarCertificados
  },

  [types.SET_ESTADO_LOTE](state, { estadoLote }) {
    state.estadoLote = estadoLote
  },

  [types.SET_TIPO_RVOE_LOTE](state, { tipoRvoeLote }) {
    state.tipoRvoeLote = tipoRvoeLote
  },
}

/**
 * Actions
 */
export const actions = {
  saveToken({ commit }, payload) {
    commit(types.SET_TOKEN, payload)
  },

  guardarBusqueda({ commit }, payload) {
    commit(types.SET_SEARCH, payload)
  },

  guardarEnviarCertificados({ commit }, payload) {
    commit(types.SET_ENVIAR_CERTIFICADOS, payload)
  },

  guardarEstadoLote({ commit }, payload) {
    commit(types.SET_ESTADO_LOTE, payload)
  },

  guardarTipoRvoeLote({ commit }, payload) {
    commit(types.SET_TIPO_RVOE_LOTE, payload)
  },

  async fetchUser({ commit }) {
    try {
      const { data } = await axios.get(api.path('me'))
      commit(types.SET_USER, data)
    } catch (e) {
      commit(types.FETCH_USER_FAILURE)
    }
  },

  setUser({ commit }, payload) {
    commit(types.SET_USER, payload)
  },

  async logout({ commit }) {
    await axios.post(api.path('logout'))
    commit(types.LOGOUT)
  },

  destroy({ commit }) {
    commit(types.LOGOUT)
  }
}

/**
 * Getters
 */
export const getters = {
  user: state => state.user,
  live_mode: state => state.user.live_mode,
  check: state => state.user !== null,
  token: state => state.token,
  busqueda: state => state.busqueda,
  enviarCertificados: state => state.enviarCertificados,
  estadoLote: state => state.estadoLote,
  tipoRvoeLote: state => state.tipoRvoeLote,
}
